<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
  props: ['item'],
  data() {
    return {
      stripe: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      paymentProcessing: false,
      agree_terms: false,
      not_refundable: false,
      cart: {
        package: {},
        services: [],
      },
    }
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
    const elements = this.stripe.elements();

    this.cardNumber = elements.create('cardNumber');
    this.cardNumber.mount('#card-number'+this.cart.id);

    this.cardExpiry = elements.create('cardExpiry');
    this.cardExpiry.mount('#card-expiry'+this.cart.id);

    this.cardCvc = elements.create('cardCvc');
    this.cardCvc.mount('#card-cvc'+this.cart.id);
  },
  created() {
    if(this.item.id) { this.cart = this.item; }
  },
  methods: {
    async submit_form() {
      if(this.paymentProcessing == true) { console.log("disabled"); return; } this.paymentProcessing = true;

      // =======================
      if(
        typeof this.cart.total == 'undefined' ||
        typeof this.cart.paid_total == 'undefined' ||
        !(this.cart.total - this.cart.paid_total > 0)
      ) {
        this.$noty.error("There was an error when gathering the amount due. Please contact our support team.");
        this.paymentProcessing = false; return;
      }
      // =======================
      if(
        !this.agree_terms ||
        !this.not_refundable
      ) {
        this.$noty.error("Before continuing you must agree to our listing agreements.");
        this.paymentProcessing = false; return;
      }

      const {paymentMethod, error} = await this.stripe.createPaymentMethod('card', this.cardNumber, {
        billing_details: {
          name: this.cart.to_name,
          email: this.cart.to_email,
          phone: this.cart.to_phone,
          address: {
            line1: this.cart.to_address,
            city: this.cart.to_city,
            state: this.cart.to_state,
            postal_code: this.cart.to_zip_code
          }
        }
      });
      if(error) {
        console.log(error);
        if(error.message) { this.$noty.error(error.message); }
        else { this.$noty.error(error); }
        this.paymentProcessing = false;
        return;
      }
      this.cart.payment_method_id = paymentMethod.id;

      this.$http.post('/carts/pay', this.cart).then(res => {
        // console.log(res);
        this.cart.status = res.data.status;
        this.cart.paid_total = res.data.paid_total;
        this.cart.paid_date = res.data.paid_date;
        this.$noty.success("Invoice payment complete. Thank you for your business.");

        this.paymentProcessing = false;
      }).catch(res => { this.popupErrors(res); this.paymentProcessing = false; });
    },
  }
}
</script>

<template>
  <div class="card small border mb-5 _box-shadow-0-1-4-b-2">

    <div class="p-4" :id="'print_invoice'+cart.id">
      <div class="row">
        <div class="col-sm-8">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="mt-0 mb-1 text-black">{{cart.from_name}}</h4>
              <div class="">{{formatPhone(cart.from_phone)}}</div>
              <div class="">{{cart.from_email}}</div>
            </div>
            <div class="col-sm-6">
              <h4 class="mt-4 mb-1 text-black">Bill to : </h4>
              <div class="">{{cart.to_name}}</div>
              <div class="">{{cart.to_email}}</div>
              <div class="">{{formatPhone(cart.to_phone)}}</div>
            </div>
            <div class="col-sm-6">
              <h4 class="mt-4 mb-1 text-black">Property : </h4>
              <div class="">{{cart.for_address}}</div>
              <div class="">{{cart.for_city}}, {{cart.for_state}} {{cart.for_zip_code}}</div>
            </div>
          </div>
        </div>
        <div class="col-sm-4 text-right">
          <h4 class="mt-0 mb-3 text-black">Invoice</h4>
          <table class="table table-sm table-borderless table-centered m-0">
            <tbody>
              <tr>
                <th class="p-1">Date issued : </th>
                <td v-if="cart.payable_date" class="p-0 text-right _w-150">{{cart.payable_date ? moment(cart.payable_date).format('MM/DD/YYYY') : ''}}</td>
              </tr>
              <tr>
                <th class="p-1">Date due : </th>
                <td class="p-0 text-right">
                  <div v-if="cart.due_date" class="">{{ cart.due_date ? moment(cart.due_date).format('MM/DD/YYYY') : ''}}</div>
                </td>
              </tr>
              <tr>
                <th class="p-1">Order status : </th>
                <td class="p-0 text-right">
                  <span class="badge border-0 py-1 px-3" :class="
                    (cart.status == 0 ? 'badge-danger' :
                    cart.status == 1 ? 'badge-purple' :
                    cart.status == 2 ? 'badge-warning' :
                    cart.status == 3 ? 'badge-success' :
                    'badge-light')
                  ">
                    {{(cart.status == 0 ? 'Void' :
                      cart.status == 1 ? 'Draft' :
                      cart.status == 2 ? 'Payable' :
                      cart.status == 3 ? 'Paid' :
                      'Unknown')}}
                  </span>
                </td>
              </tr>
              <tr>
                <th class="p-1">Order number : </th>
                <td class="p-0 text-right">{{cart.id}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-6">
          <div class="text-pre-wrap">{{cart.intro}}</div>
        </div>
        <div class="col-sm-6 text-right">

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table border-bottom border-light mt-4">
              <thead>
                <tr>
                  <th class="border-light">Item</th>
                  <th style="width: 10%" class="border-light">Quantity</th>
                  <th style="width: 10%" class="border-light">Unit price</th>
                  <th style="width: 10%" class="border-light text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="cart.package && Object.keys(cart.package).length">
                  <td class="border-light">
                    <div class="font-weight-bold text-black">{{cart.package.title}} Package</div>
                    <p v-for="(pack_serv, pack_serv_i) in cart.package.services" :key="'a'+pack_serv_i" class="m-0 small">{{pack_serv.title}}</p>
                    <div v-if="cart.package.notes" class="small text-muted border-top border-light mt-1 pt-1 text-pre-wrap">{{cart.package.notes}}</div>
                  </td>
                  <td class="border-light">1</td>
                  <td class="border-light">
                    <div class="">{{formatPrice(cart.package.price)}}</div>
                  </td>
                  <td class="border-light text-right">{{formatPrice(cart.package.price * (cart.package.quantity ? cart.package.quantity : 1))}}</td>
                </tr>
                <tr v-for="(serv, serv_i) in cart.services" :key="'b'+serv_i">
                  <td class="border-light">
                    <div class="font-weight-bold text-black">{{serv.title}}</div>
                    <div v-if="serv.notes" class="small text-muted border-top border-light mt-1 pt-1 text-pre-wrap">{{serv.notes}}</div>
                  </td>
                  <td class="border-light">
                    <div>{{(serv.quantity ? serv.quantity : '1')}}</div>
                  </td>
                  <td class="border-light">
                    <div>{{formatPrice(serv.price)}}</div>
                  </td>
                  <td class="border-light text-right">{{formatPrice(serv.price * (serv.quantity ? serv.quantity : '1'))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="clearfix pt-5">
            <div v-if="cart.outro" class="text-pre-wrap small">{{cart.outro}}</div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="float-right">
            <div class="py-1">
              <b>Subtotal : </b> <span class="float-right ml-4">{{formatPrice(cart.sub_total)}}</span>
            </div>
            <div class="py-1" v-if="cart.discount_total > 0">
              <b>Discount : </b><span class="float-right ml-4">-{{formatPrice(cart.discount_total)}}</span>
            </div>
            <div class="py-1 font-weight-bold text-dark">
              Total : <span class="float-right ml-4">{{formatPrice(cart.total)}}</span>
            </div>
            <div class="py-1" v-if="cart.paid_total > 0">
              <b>Amount paid : </b><span class="float-right ml-4">-{{formatPrice(cart.paid_total)}}</span>
            </div>
            <div class="py-1" v-if="cart.paid_total > 0">
              <b>Amount due : </b><span class="float-right ml-4">{{formatPrice(cart.total - cart.paid_total)}}</span>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div v-if="cart.cart_hash || cart.listing_id" class="col-sm-12 small pt-3">
          <div v-if="cart.cart_hash" class="small">
            <strong>Invoice URL:</strong> <a :href="app_url+'/invoice/'+cart.cart_hash" target="_blank">{{app_url+'/invoice/'+cart.cart_hash}}</a>
          </div>
          <div v-if="cart.listing_id" class="small">
            <strong>Listing URL:</strong> <a :href="app_url+'/my-listings/'+cart.listing_id" target="_blank">{{app_url+'/my-listings/'+cart.listing_id}}</a>
          </div>
        </div>
      </div>
    </div>

    <div v-show="cart.status == 2 && cart.total > 0" class="p-4 border-top border-light">
      <div class="row">
        <div class="col-sm _w-m-250 border-right border-light">
          <h5 class="mb-3">Enter payment information</h5>
          <small class="text-muted">Processed securely through <a href="https://stripe.com/" target="_blank">Stripe</a>.</small>
          <img src="/images/stripe-payment-logo.png" class="_w-m-150 mt-1">
        </div>
        <div class="col-sm">
          <!-- <div id="card-element" class="form-control" style="padding-top: 0.6rem !important"></div> -->
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="field-BillingName">Name on card <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <input id="field-BillingName" name="address" type="text" class="form-control" v-model="cart.to_name" required>
                <small class="text-muted"></small>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="field-to_address">Billing address <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <input id="field-to_address" name="address" type="text" class="form-control" v-model="cart.to_address" required>
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="field-to_city">Billing city <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
                <input id="field-to_city" name="city" type="text" class="form-control" v-model="cart.to_city" required>
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="field-to_state">Billing state <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <select id="field-to_state" name="state" class="form-control" v-model="cart.to_state" required>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="field-to_zip_code">Billing zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <input id="field-to_zip_code" name="zip_code" type="text" class="form-control" v-model="cart.to_zip_code" required>
                <small class="text-muted"></small>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-12 mb-3">
              <label :for="'card-number'+cart.id" class="d-block">Card number <span class="text-danger" v-tippy content="This field is required.">*</span></label>
              <div :id="'card-number'+cart.id" class="form-control" style="padding-top: 0.6rem !important"></div>
            </div>
            <div class="col-sm-6 mb-3">
              <label :for="'card-expiry'+cart.id" class="d-block">Expiration date <span class="text-danger" v-tippy content="This field is required.">*</span></label>
              <div :id="'card-expiry'+cart.id" class="form-control" style="padding-top: 0.6rem !important"></div>
            </div>
            <div class="col-sm-6 mb-3">
              <label :for="'card-cvc'+cart.id" class="d-block">CVC code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
              <div :id="'card-cvc'+cart.id" class="form-control" style="padding-top: 0.6rem !important"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="cart.status == 2 && cart.total > 0" class="p-4 border-top border-light">
      <h5 class="mb-3">Listing agreements</h5>
      <div class="mb-2">
        <p-check class="p-default p-curve p-smooth" color="success" v-model="agree_terms" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I agree to {{app_name}}'s terms of service. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
      </div>
      <div class="mb-2">
        <p-check class="p-default p-curve p-smooth" color="success" v-model="not_refundable" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I understand that all sales are final and not refundable. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
      </div>
    </div>

    <div class="p-4">
      <div class="row">
        <div class="col-sm-6">
          <button type="button" :target="'print_invoice'+cart.id" class="btn btn-white print_target mr-1" :disabled="paymentProcessing"><Icon icon="ri:printer-line" /> Print</button>
        </div>
        <div class="col-sm-6 text-right">
          <button v-if="cart.status == 2 && cart.total > 0" type="button" class="btn btn-success ml-1" @click="submit_form()" :disabled="paymentProcessing">
            <span v-show="paymentProcessing" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!paymentProcessing" icon="ri:check-line" class="mr-1" />
            Submit payment
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
